import script from "./deploy-section-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./deploy-section-card.vue?vue&type=script&lang=ts&setup=true"

import "./deploy-section-card.vue?vue&type=style&index=0&id=15e52125&lang=scss&scoped=true"
import "./deploy-section-card.vue?vue&type=style&index=1&id=15e52125&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e52125"]])

export default __exports__